module.exports = __webpack_public_path__ + "images/emoji/ballot_box_with_check.37fe1d042ca595da2ec8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ballot_box_with_check.png
// module id = Xuvh
// module chunks = 2